const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

export interface StaffMember {
  id: string;
  name: string;
  email: string;
  phone: string;
  role: string;
  department: string;
  maxLeads: number;
  currentLeads: number;
  specialties: string[];
  preferredChannels: string[];
  workingHours: {
    weekdays: string;
    saturday: string;
    sunday: string;
  };
  isActive: boolean;
  createdAt: string;
}

class StaffService {
  async getStaffMembers(): Promise<StaffMember[]> {
    try {
      const response = await fetch(`${API_BASE_URL}/v1/staff`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('auth-token')}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch staff members');
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching staff members:', error);
      return [];
    }
  }

  async createStaffMember(member: Omit<StaffMember, 'id' | 'currentLeads' | 'createdAt'>): Promise<StaffMember | null> {
    try {
      const response = await fetch(`${API_BASE_URL}/v1/staff`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('auth-token')}`,
        },
        body: JSON.stringify(member),
      });

      if (!response.ok) {
        throw new Error('Failed to create staff member');
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating staff member:', error);
      return null;
    }
  }

  async updateStaffMember(id: string, updates: Partial<StaffMember>): Promise<StaffMember | null> {
    try {
      const response = await fetch(`${API_BASE_URL}/v1/staff/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('auth-token')}`,
        },
        body: JSON.stringify(updates),
      });

      if (!response.ok) {
        throw new Error('Failed to update staff member');
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating staff member:', error);
      return null;
    }
  }

  async deleteStaffMember(id: string): Promise<boolean> {
    try {
      const response = await fetch(`${API_BASE_URL}/v1/staff/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('auth-token')}`,
        },
      });

      return response.ok;
    } catch (error) {
      console.error('Error deleting staff member:', error);
      return false;
    }
  }
}

export const staffService = new StaffService();